<div class="activities-bg">
</div>
<div id="outer_container">
    <div class="container-fluid noPadding">
    <!-- uiView: content -->
        <div
            id="content"
            ui-view="content"
            class="angular-animate ng-scope"
            autoscroll="true"
            mtc-scroll-to-invalid=""
        >
            <!-- video controls -->
            <!-- <div class="video-control">
                <button id="myBtn" class="btn2 btn2-light" onclick="myFunction()"></button>
            </div> -->
            <!-- video controls -->
            <div class="ng-scope">
            <div class="container">
                <div class="home">
                    <div class="type-container ng-scope">
                        <div class="type-headline">
                            <h1>Activities</h1>
                        </div>
                        <div class="type-copy">
                            <p>
                                During your trip, a variety of activities will be offered for you to enjoy the best of Monte Carlo. 
                                For your Days at Leisure on Tuesday, March 16 and Friday, March 19, an optional Day in the City Your 
                                Way is offered either of these days with curated experiences to highlight one of three nearby cities.
                            </p>
                            <p class="text-center f-24 mb-0">
                                <strong>Sponsored Activities</strong><br>
                                <strong>Offered: Wednesday, March 17 and Thursday, March 18</strong></p>
                            <p>
                                You may select one sponsored activity per person, per day, during registration. The list below provides a 
                                general idea of what the activities will entail to allow you to make your selections.
                            </p>
                            <p>
                                Your activity selections will be confirmed at the Golden Eagle Club Hospitality Desk upon arrival. 
                                Please note that on-site changes are limited and based on availability. Activity offerings are also 
                                subject to change based on participation.
                            </p>                          
                        </div>

                        <div class="card-deck justify-content-center mx-4 mt-4">
                            <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                <img class="card-img-top" src="assets/images/activities/flowerMaking.jpg" alt="Card image cap">
                                <div class="card-body">
                                    <h5 class="card-title greycliff-cf-bold">Flower Market in Nice with Wine Tasting, Shopping & Lunch</h5>
                                </div>
                                <div class="card-footer">
                                    <a data-bs-toggle="modal" data-bs-target="#flowerMakingModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                </div>
                            </div>
                            <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                <img class="card-img-top" src="assets/images/activities/casinoMonaco.jpg" alt="Card image cap">
                                <div class="card-body">
                                    <h5 class="card-title greycliff-cf-bold">Mythic Monte-Carlo Casino & Highlights of Monaco</h5>
                                    
                                </div>
                                <div class="card-footer">
                                    <a data-bs-toggle="modal" data-bs-target="#casinoMonacoModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                </div>
                            </div>
                            <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                <img class="card-img-top" src="assets/images/activities/wineTasting.jpg" alt="Card image cap">
                                <div class="card-body">
                                    <h5 class="card-title greycliff-cf-bold">Wine Tasting in the Footsteps of Coco Chanel</h5>
                                    
                                </div>
                                <div class="card-footer">
                                    <a data-bs-toggle="modal" data-bs-target="#wineTastingModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                </div>
                            </div>
                        </div>

                        <div class="card-deck justify-content-center mx-4 mt-4">
                            <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                <img class="card-img-top" src="assets/images/activities/stPaul.jpg" alt="Card image cap">
                                <div class="card-body">
                                    <h5 class="card-title greycliff-cf-bold">St. Paul De Vence - Life of the Artist</h5>
                                    
                                </div>
                                <div class="card-footer">
                                    <a data-bs-toggle="modal" data-bs-target="#stPaulModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                </div>
                            </div>
                            <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                <img class="card-img-top" src="assets/images/activities/lemonCruise.png" alt="Card image cap">
                                <div class="card-body">
                                    <h5 class="card-title greycliff-cf-bold">Sightseeing Cruise to Menton "City of the Lemon" & Lunch</h5>
                                    
                                </div>
                                <div class="card-footer">
                                    <a data-bs-toggle="modal" data-bs-target="#lemonCruiseModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                </div>
                            </div>
                            <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                <img class="card-img-top" src="assets/images/activities/miniCruise.jpg" alt="Card image cap">
                                <div class="card-body">
                                    <h5 class="card-title greycliff-cf-bold">Mini Cruise by Maxi Catamaran to Villefranche, Seafront Lunch & Visit Villa Rothschild</h5>
                                    
                                </div>
                                <div class="card-footer">
                                    <a data-bs-toggle="modal" data-bs-target="#miniCruiseModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                </div>
                            </div>
                        </div>

                        <div class="card-deck justify-content-center mx-4 mt-4">
                            <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                <img class="card-img-top" src="assets/images/activities/mountainHike.png" alt="Card image cap">
                                <div class="card-body">
                                    <h5 class="card-title greycliff-cf-bold">Mountain Hike & Lunch Auberge</h5>
                                    
                                </div>
                                <div class="card-footer">
                                    <a data-bs-toggle="modal" data-bs-target="#mountainHikeModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                </div>
                            </div>
                            <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                <img class="card-img-top" src="assets/images/activities/bikeTour.jpg" alt="Card image cap">
                                <div class="card-body">
                                    <h5 class="card-title greycliff-cf-bold">Panoramic Biking Tour & Lunch</h5>
                                    
                                </div>
                                <div class="card-footer">
                                    <a data-bs-toggle="modal" data-bs-target="#bikeTourModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                </div>
                            </div>
                            <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                <img class="card-img-top" src="assets/images/activities/royalMonaco.png" alt="Card image cap">
                                <div class="card-body">
                                    <h5 class="card-title greycliff-cf-bold">Royal Monaco</h5>
                                    
                                </div>
                                <div class="card-footer">
                                    <a data-bs-toggle="modal" data-bs-target="#royalMonacoModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                </div>
                            </div>
                        </div>

                        <div class="card-deck justify-content-center mx-4 mt-4">
                            <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                <img class="card-img-top" src="assets/images/activities/princeCar.jpg" alt="Card image cap">
                                <div class="card-body">
                                    <h5 class="card-title greycliff-cf-bold">Prince Of Monaco's Car Collection & Distillerie Tasting</h5>
                                    
                                </div>
                                <div class="card-footer">
                                    <a data-bs-toggle="modal" data-bs-target="#princeCarModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                </div>
                            </div>
                            <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                <img class="card-img-top" src="assets/images/activities/fairytale.jpg" alt="Card image cap">
                                <div class="card-body">
                                    <h5 class="card-title greycliff-cf-bold">Fairytale Village Of Éze and Perfume Factory</h5>
                                    
                                </div>
                                <div class="card-footer">
                                    <a data-bs-toggle="modal" data-bs-target="#fairytaleModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                </div>
                            </div>
                            <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                <img class="card-img-top" src="assets/images/activities/cooking.jpg" alt="Card image cap">
                                <div class="card-body">
                                    <h5 class="card-title greycliff-cf-bold">Cooking Experience & Wine Tasting</h5>
                                    
                                </div>
                                <div class="card-footer">
                                    <a data-bs-toggle="modal" data-bs-target="#cookingModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                </div>
                            </div>
                        </div>

                        <div class="card-deck justify-content-center mx-4 mt-4 mb-2">
                            <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                <img class="card-img-top" src="assets/images/activities/villa.jpg" alt="Card image cap">
                                <div class="card-body">
                                    <h5 class="card-title greycliff-cf-bold">Highlights of Villefranche & Villa Rothschild</h5>
                                    
                                </div>
                                <div class="card-footer">
                                    <a data-bs-toggle="modal" data-bs-target="#villaModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                </div>
                            </div>
                            <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                <img class="card-img-top" src="assets/images/activities/spa.jpeg" alt="Card image cap">
                                <div class="card-body">
                                    <h5 class="card-title greycliff-cf-bold">Spa Treatment at Fairmont Spa Monte Carlo</h5>
                                    
                                </div>
                                <div class="card-footer">
                                    <a data-bs-toggle="modal" data-bs-target="#spaModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                </div>
                            </div>
                        </div>

                        <div class="type-copy">
                          <p class="text-center f-18 mb-n1">
                            <strong>Day(s) at Leisure or Day in the City Your Way</strong></p>
                          <p>
                            For your Days at Leisure on Tuesday, March 16 and Friday, March 19, an optional Day in the City Your Way 
                            is offered either of these days with the opportunity to curate your own experience as you explore the highlights 
                            of the area or enjoy both days fully at your leisure. Each attendee may select one of the below excursions on either 
                            day or enjoy two full days at leisure on your own.
                          </p>
                          <ul>
                              <li>Please wear comfortable walking shoes and keep your photo ID with you. A map with points of interest will be provided. Lunch will be at 
                                  leisure on own which may be expensed back to your zone cost center. Lunch allowance is $75 USD per person.</li>
                                  <li>All the excursions below are self-guided, as you determine how you’d like your ideal day in the city to unfold.</li>
                          </ul>                            
                        </div>

                        <div class="card-deck justify-content-center mx-4 mt-4">
                            <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                <img class="card-img-top" src="assets/images/activities/nice.jpg" alt="Card image cap">
                                <div class="card-body">
                                    <h5 class="card-title greycliff-cf-bold">Nice – The Capital of the French Riveria</h5>
                                    
                                </div>
                                <div class="card-footer">
                                    <a data-bs-toggle="modal" data-bs-target="#capitalModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                </div>
                            </div>
                            <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                <img class="card-img-top" src="assets/images/activities/dolce-vita.jpg" alt="Card image cap">
                                <div class="card-body">
                                    <h5 class="card-title greycliff-cf-bold">Dolce Vita & Shopping in Italy</h5>
                                    
                                </div>
                                <div class="card-footer">
                                    <a data-bs-toggle="modal" data-bs-target="#shoppingModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                </div>
                            </div>
                        </div>
                        <div class="card-deck justify-content-center mx-4 mt-4">
                            <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                <img class="card-img-top" src="assets/images/activities/cannes.jpg" alt="Card image cap">
                                <div class="card-body">
                                    <h5 class="card-title greycliff-cf-bold">Cannes – City of the Stars</h5>
                                    
                                </div>
                                <div class="card-footer">
                                    <a data-bs-toggle="modal" data-bs-target="#cannesModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                </div>
                            </div>
                            <div class="card mb-4 mb-lg-0 mx-auto mx-lg-0 me-lg-4">
                                <img class="card-img-top" src="assets/images/activities/menton.jpg" alt="Card image cap">
                                <div class="card-body">
                                    <h5 class="card-title greycliff-cf-bold">Menton "City of the Lemon"</h5>
                                    
                                </div>
                                <div class="card-footer">
                                    <a data-bs-toggle="modal" data-bs-target="#lemonModal" class="card-btn stretched-link">Learn more<img class="chevron" src="assets/icons/chevron_right.svg"></a>
                                </div>
                            </div>
                        </div>

                        <div class="type-copy">
                            <p>
                                <strong>The tours and activities included in your travel program and those available on an optional basis are planned, conducted, operated and performed by independent companies that are not affiliated with Siemens DISW or Maritz Global Events Inc.</strong>
                            </p>
                            <p>
                                <strong>Prior to engaging in certain optional excursions involving participation in off-road, airborne, waterborne or similar adventure-oriented activities, participants will be required to sign an assumption of risk/liability release form.</strong>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="flowerMakingModal" tabindex="-1" aria-labelledby="flowerMakingLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0 row g-0">
        <img class="activity-img" src="assets/images/activities/flowerMaking.jpg">
        <h5 class="modal-title col-11 col-11" id="flowerMakingLabel">Flower Market in Nice with Wine Tasting, Shopping & Lunch</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
            <p><strong>Offered: </strong>Wednesday, March 17 and Thursday, March 18<br>
            <strong>Time: </strong>8:15 AM &ndash; 3:45 PM<br>
            <strong>Duration:</strong> 7.45 hours, includes transfer time<br>
            <strong>Fitness Level: </strong>Easy</p>
            <p>The celebrated capital of the French Riviera, Nice is an iconic Mediterranean destination, where coastal beauty, 
                local flavor and Old World character combine for a seaside excursion that&rsquo;s magnifique! Your adventure begins 
                with a cruise along the glittering coastline between Monaco and Nice, a dreamy stretch of idyllic coves and capes capped 
                with green patches of pine trees and cypresses and palatial villas tucked into the hillsides. Once in Nice, you&rsquo;ll 
                experience the city&rsquo;s oldest wine cellar for a curated tasting before exploring the vibrant Cours Saleya Flower Market. 
                A symbol of the Provence-Alpes-C&ocirc;te d&rsquo;Azur region, the sights, sounds and fragrances of the market create a feast 
                for the senses. You&rsquo;ll also have time to explore the narrow streets, bustling with local life and lined with artisan shops, 
                elegant villas and baroque churches. For the piece de resistance, lunch in a classic French restaurant in Old Town is the perfect ending to your adventure in Nice.</p>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="casinoMonacoModal" tabindex="-1" aria-labelledby="casinoMonacoLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/activities/casinoMonaco.jpg">
        <h5 class="modal-title col-11" id="casinoMonacoLabel">Mythic Monte-Carlo Casino & Highlights of Monaco </h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>Offered: </strong>Wednesday, March 17 and Thursday, March 18<br>
        <strong>Time: </strong>9:15 AM &ndash; 2:00 PM<br>
        <strong>Duration: </strong>4.5 hours, includes transfer time<br>
        <strong>Difficulty Level: </strong>Easy</p>
        <p>Visit the legendary Monte-Carlo Casino, where Belle &Eacute;poque grandeur and timeless glamour evoke the mystique 
            of a tuxedo-clad James Bond with martini in hand and high-society high rollers dancing with lady luck around posh gaming tables. 
            Your tour will include other landmarks of Monaco as you travel aboard the charming Little Train, taking in the principality&rsquo;s 
            iconic highlights and scenic views of the Mediterranean before enjoying lunch in the heart of Monte Carlo.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="wineTastingModal" tabindex="-1" aria-labelledby="wineTastingLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/activities/wineTasting.jpg">
        <h5 class="modal-title col-11" id="wineTastingLabel">Wine Tasting in the Footsteps of Coco Chanel</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>Offered: </strong>Wednesday, March 17 and Thursday, March 18<br>
        <strong>Time: </strong>9:15 AM &ndash; 3:00 PM<br>
        <strong>Duration: </strong>5.5 hours, includes transfer time<br>
        <strong>Difficulty Level: </strong>Easy</p>
        <p>A hidden chapter of Riviera history is revealed with a visit to an exclusive ch&acirc;teau tucked into the hills above Nice, 
            in the heart of the Bellet vineyards. One of the oldest vineyards in France, the vines here were first planted by the Roman legions. 
            These organically grown grapes are what produce the eco-friendly, high-quality wines of the Ch&acirc;teau de Cr&eacute;mat. 
            You&rsquo;ll also tour the wine cellars and the elegant interior of the chateau, learning of its history and its ties to the 
            famed designer, Coco Chanel. When the chateau was renovated, the furnishings were curated from the Ritz in Paris, including the 
            mythical Coco Chanel Suite. A guided wine tasting completes your tour at the winery before transportation returns you to Monaco for a seaside lunch.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="stPaulModal" tabindex="-1" aria-labelledby="stPaulLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/activities/stPaul.jpg">
        <h5 class="modal-title col-11" id="stPaulLabel">St. Paul De Vence - Life of the Artist </h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>Offered: </strong>Wednesday, March 17 and Thursday, March 18<br>
        <strong>Time: </strong>8:45 AM &ndash; 4:00 PM<br>
        <strong>Duration: </strong>6.45 hours, includes transfer time<br>
        <strong>Difficulty Level: </strong>Easy</p>
        <p>One of the oldest medieval towns in France, Saint-Paul de Vence is a walled village set like a crown
             jewel among the French Riviera&rsquo;s string of charming, storybook hamlets. It is the artistic nature 
             of the town that gives Saint-Paul de Vence its unique, captivating quality. A wealth of vibrant art galleries 
             and museums, perfectly patinaed cobblestone streets and hidden passageways, and picture-postcard hillsides, all set 
             against the breathtaking backdrop of the Mediterranean Sea create a living canvas that has inspired legendary and aspiring 
             artists for the past century and more. You can trace the footsteps of renowned masters like Marc Chagall, Pablo Picasso and Henri Matisse, 
             who lived or worked in the village, drawn by the rich history, medieval architecture and stunning natural beauty. You&rsquo;ll also enjoy a 
             guided tasting of local wines in a historic cellar. A lunch of contemporary Mediterranean cuisine will be served at a restaurant in Saint Paul de Vence, 
             a favorite spot of famous architects, artists and film stars due to its unique charm. This tour lets you truly experience the &ldquo;art of living,&rdquo; a 
             multi-sensory effect that this tiny, hilltop town has on all who are lucky enough to visit. See how it inspires you.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="lemonCruiseModal" tabindex="-1" aria-labelledby="lemonCruiseLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/activities/lemonCruise.png">
        <h5 class="modal-title col-11" id="lemonCruiseLabel">Sightseeing Cruise to Menton "City of the Lemon" & Lunch</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>Offered: </strong>Wednesday, March 17 and Thursday, March 18<br>
        <strong>Time: </strong>9:00 AM &ndash; 3:00 PM<br>
        <strong>Duration: </strong>5.45 hours, includes transfer time<br>
        <strong>Difficulty Level: </strong>Easy</p>
        <p>Experience the best of the French Riviera with this unforgettable excursion to the enchanting town of Menton, the &ldquo;Pearl of France.&rdquo; 
            Cruise along the stunning coastline, taking in the sights of Monaco and the Riviera's natural beauty on your way to this historic town at the border of 
            France and Italy. Discover the charm of Menton as you explore its architectural treasures, including the 17<sup>th</sup>-century Basilica Saint-Michele-Archange, 
            browse the narrow streets of the pastel-hued Old Town, and savor a unique jam tasting at a local factory. These artisanal jams are produced from the famous Menton 
            lemons and other citrus grown in this ideal Mediterranean climate. You&rsquo;ll also enjoy a delicious lunch at a classic restaurant in Old Town before returning to Monte Carlo.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="miniCruiseModal" tabindex="-1" aria-labelledby="miniCruiseLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/activities/miniCruise.jpg">
        <h5 class="modal-title col-11" id="miniCruiseLabel">Mini Cruise by Maxi Catamaran to Villefranche, Seafront Lunch & Visit Villa Rothschild</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>Offered: </strong>Wednesday, March 17 and Thursday, March 18<br>
        <strong>Time: </strong>9:45 AM &ndash; 4:45 PM<br>
        <strong>Duration: </strong>6.45 hours, includes transfer time<br>
        <strong>Difficulty Level: </strong>Easy</p>
        <p>Set sail in a maxi-catamaran along the glamorous French Riviera and discover the idyllic coves and 
            capes dotted with luxury yachts and crisp white sails as you cruise the mesmerizing blue waters of the 
            Mediterranean before or after lunch. The enchanting backdrop of palatial villas tucked into the hillsides of 
            cypress and pine trees, contrasting with the spectacular, white-limestone cliffs is a page right out of a travel 
            magazine. Your captain will navigate to the charming fisherman&rsquo;s village of Villefranche-sur-Mer, where you&rsquo;ll disembark
             for a guided walk through the Rue Obscure. This unusual street is a rare covered medieval passage dating to 1260 that winds beneath 
             the old quarter. You&rsquo;ll also visit the renowned Villa Ephrussi de Rothschild in Saint-Jean-Cap-Ferrat, 
             one of the C&ocirc;te d&rsquo;Azur&rsquo;s most beautiful estates. The iconic pink Belle &Eacute;poque villa offers a glimpse into 
             the luxury, elegance, and grandeur of the French Riviera&rsquo;s golden age. Lunch is included at a seafront restaurant.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="mountainHikeModal" tabindex="-1" aria-labelledby="mountainHikeLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/activities/mountainHike.png">
        <h5 class="modal-title col-11" id="mountainHikeLabel">Mountain Hike & Lunch Auberge</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>Offered: </strong>Wednesday, March 17 and Thursday, March 18<br>
        <strong>Time: </strong>8:00 AM &ndash; 3:00 PM<br>
        <strong>Duration:</strong> 6.45 hours, includes transfer time<br>
        <strong>Difficulty Level: </strong>Moderate</p>
        <p>Embark on an exhilarating journey to the medieval villages of Peille and Peillon. After a 
            scenic drive to Peille, you&rsquo;ll begin a magical hike through fragrant lavender and thyme fields and shaded 
            forests, far from the tourist crowds. Along the way, you&rsquo;ll pass a romantic chapel and a breathtaking canyon 
            overlooking the Maritime Alps. As you approach the final stretch, Peillon reveals itself in the distance. Like a snowcap on 
            the mountain, this hilltop village is perched dramatically on a rocky spur, bordered by olive groves on one side and a deep 
            ravine on the other &mdash; a spectacular, almost surreal vision that comes into focus as you approach. Once you arrive, you 
            can explore the storybook pedestrian-only streets, winding stairways and hidden squares before transferring to Auberge for lunch 
            in an intimate restaurant. Please note that this hike covers an elevation range from 40 to 700 meters above sea level, with a total 
            uphill climb of approximately 560 to 700 meters, depending on the exact route.</p>
        <p><strong>Note:</strong> You will need to wear good walking shoes and layered athletic clothing to adjust to the changes in temperature.
             A backpack with mineral water, an apple and an energy bar will be provided. Hiking tour duration is 2.5 hours.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="bikeTourModal" tabindex="-1" aria-labelledby="bikeTourLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/activities/bikeTour.jpg">
        <h5 class="modal-title col-11" id="bikeTourLabel">Panoramic Biking Tour & Lunch</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>Offered: </strong>Wednesday, March 17 and Thursday, March 18<br>
        <strong>Time: </strong>8:00 AM &ndash; 2:30 PM, includes transfer time<br>
        <strong>Duration:</strong> 6.15 hours<br>
        <strong>Difficulty Level: </strong>Moderate</p>
        <p>After transferring to Nice, you&rsquo;ll be personally fitted for equipment before setting out on a 
            two-hour tour on two wheels. Following your guide, you&rsquo;ll enjoy a scenic coastal route, mainly downhill, that provides 
            dazzling panoramic views of the Baie des Anges, Villefranche Bay and the quaint seaside villages nestled in sun-splashed hills 
            where they meet the sea. The route begins at an elevation of approximately 190 to 220 meters and descends to sea level, with a 
            total descent of around 220 meters depending on the exact route and GPS recording. With expert guides to point out the highlights 
            and a refreshing pause for coffee or a drink along the way, this is the perfect way to take in the Riviera. Your exhilarating ride 
            concludes in Cap Ferrat with lunch overlooking the harbor in the adjacent village of Villefranche-sur-Mer. Participants should be 
            familiar with biking, as the activity will involve approximately two hours of cycling.</p>
        <p><strong>Note:</strong> You will need to wear flat, closed-toe athletic shoes and comfortable athletic clothing. A backpack, helmet and gloves will be provided.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="royalMonacoModal" tabindex="-1" aria-labelledby="royalMonacoLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/activities/royalMonaco.png">
        <h5 class="modal-title col-11" id="royalMonacoLabel">Royal Monaco</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>Offered: </strong>Wednesday, March 17 and Thursday, March 18<br>
        <strong>Time: </strong>10:00 AM &ndash; 3:00 PM or 11:00 AM &ndash; 4:00 PM<br>
        <strong>Duration: </strong>5 hours, includes transfer time<br>
        <strong>Difficulty Level: </strong>Easy</p>
        <p>Uncover the rich history and pageantry of Monaco's royal family on this exclusive tour. 
            Explore the Old Town of Monaco and discover how this tiny country, ruled by the Grimaldi family form more than 700 years, 
            became a legendary destination for royalty, tycoons, artists, celebrities, athletes and elite travelers the world over. 
            Your guide will lead you through the Old Town&rsquo;s winding medieval alleyways to admire the 13th-century Cathedral, the 
            site of Prince Rainier III and Princess Grace's wedding and final resting place of former Princes. With its vast balustrade 
            overlooking the sea from its perch upon &ldquo;the Rock,&rdquo; the Palace is an iconic symbol of the city. Here you can take 
            in the ceremonial pomp and circumstance of the changing of the guard at the palace&rsquo;s main entrance &ndash; a regal 
            spectacle to behold. Lunch is included at a traditional Mediterranean-style restaurant near the palace.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="princeCarModal" tabindex="-1" aria-labelledby="princeCarLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/activities/princeCar.jpg">
        <h5 class="modal-title col-11" id="princeCarLabel">Prince Of Monaco's Car Collection & Distillerie Tasting</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>Offered: </strong>Wednesday, March 17 and Thursday, March 18<br>
        <strong>Time: </strong>10:15 AM &ndash; 2:30 PM or 12:15 PM &ndash; 4:30 PM<br>
        <strong>Duration: </strong>4.30 hours<br>
        <strong>Difficulty Level: </strong>Easy</p>
        <p>Car buffs, start your engines! This tour gives you an exclusive opportunity to visit Prince Albert&rsquo;s 
            remarkable private collection of vintage cars, where rare and exceptional automobiles offer a fascinating 
            journey through design, innovation and royal heritage. In keeping with the flavor of this refined experience, 
            you&rsquo;ll also visit La Distillerie de Monaco for a tasting of the spirit of the principality. This artisanal 
            craft distillery is the first in Monaco, specializing in handcrafted spirits and liqueurs made with local fruit and 
            botanicals. This stop will serve as your ap&eacute;ritif or digestif, depending whether you participate in the morning 
            or afternoon excursion. Lunch is included at an iconic waterfront restaurant in the Port of Monaco.</p>
        <p><strong>Note:</strong> Comfortable walking shoes are recommended.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="fairytaleModal" tabindex="-1" aria-labelledby="fairytaleLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/activities/fairytale.jpg">
        <h5 class="modal-title col-11" id="fairytaleLabel">Fairytale Village Of Éze and Perfume Factory</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>Offered: </strong>Wednesday, March 17 and Thursday, March 18<br>
        <strong>Time: </strong>8:15 AM &ndash; 2:15 PM or 11:30 AM &ndash; 5:15 PM<br>
        <strong>Duration: </strong>5.45 hours, includes transfer time<br>
        <strong>Difficulty Level:</strong> Easy to Moderate* (uphill steps)</p>
        <p>Perched in the mountains, 1,200 feet above sea level, the enchanting seaside town 
            of &Egrave;ze is surrounded by fields of jasmine, roses, lavender and other blossoms. 
            Along with its neighboring towns, &Egrave;ze is responsible for nearly three-quarters of 
            the world&rsquo;s flower essences. Your visit to this picturesque town includes a stop at the Exotic 
            Garden of Eze, set on the site of a medieval fortress. Bursting with blooms and exotic foliage, this magical
             garden also provides one of the most spectacular vantage points along the French Riviera. From the garden, 
             you&rsquo;ll head to a perfume factory where you&rsquo;ll get an exclusive glimpse into the making of perfume 
             from the local flora to the bottled product. After a tour of the factory, you&rsquo;ll learn the nuances of crafting 
             new scents and have the opportunity to create your very own signature fragrance. Lunch is included in a seaside restaurant.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="cookingModal" tabindex="-1" aria-labelledby="cookingLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/activities/cooking.jpg">
        <h5 class="modal-title col-11" id="cookingLabel">Cooking Experience & Wine Tasting</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>Offered: </strong>Wednesday, March 17 and Thursday, March 18<br>
        <strong>Time: </strong>9:30 AM &ndash; 3:45 PM<br>
        <strong>Duration: </strong>6 hours, includes transfer time<br>
        <strong>Difficulty Level:</strong> Easy</p>
        <p>Discover the flavors of the C&ocirc;te d&rsquo;Azur through a hands-on food and wine experience. 
            Learn about the history of the iconic <em>pan bagnat</em> and prepare this regional specialty using fresh local 
            ingredients, then create traditional olive tapenade while exploring Proven&ccedil;al culinary traditions. 
            The experience also includes a tasting of acclaimed Bellet wines, produced by one of the region&rsquo;s most 
            renowned vineyards, whose wines were served at the wedding of Prince Albert II of Monaco and Princess Charlene. 
            A leisurely lunch paired with three wines completes this authentic culinary journey through the French Riviera.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="villaModal" tabindex="-1" aria-labelledby="villaLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/activities/villa.jpg">
        <h5 class="modal-title col-11" id="villaLabel">Highlights of Villefranche & Villa Rothschild</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>Offered: </strong>Wednesday, March 17 and Thursday, March 18<br>
        <strong>Time: </strong>11:15 AM &ndash; 4:30 PM<br>
        <strong>Duration: </strong>5 hours<br>
        <strong>Difficulty Level:</strong> Easy</p>
        <p>Step back in time to the Belle &Eacute;poque (Beautiful Era) with a visit to the famed Villa 
            Ephrussi de Rothschild, the French Riviera&rsquo;s own &ldquo;Little Versailles.&rdquo; Presiding 
            over the exclusive enclave of Saint-Jean-Cap-Ferrat, a favorite getaway of international glitterati, 
            this magnificent estate gleams with pink-hued splendor and nine themed gardens that collectively capture 
            the grandeur of a bygone era. Your excursion also includes a walking tour of Villefranche-sur-Mer, one of 
            the Riviera&rsquo;s most photogenic villages due to its colorful buildings that mirror the warm hues of the 
            Mediterranean sunsets. Wandering the winding medieval streets of Old Town is an attraction in itself, especially
             the fascinating Rue Obscure, a hidden passage beneath Old Town that dates to the 13<sup>th</sup> century and 
             was originally used for military purposes. Historic fortifications and sweeping views across one of the Mediterranean's 
             most beautiful natural harbors add to the allure of this quintessential Riviera town. Lunch will be provided.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="spaModal" tabindex="-1" aria-labelledby="spaLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/activities/spa.jpeg">
        <h5 class="modal-title col-11" id="spaLabel">Spa Treatment at Fairmont Spa Monte Carlo </h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>Offered: </strong>Wednesday, March 17 and Thursday, March 18<br>
        <strong>Time: </strong>Times will be provided at the Hospitality Desk at check-in<br>
        <strong>Duration:</strong> 50 minutes</p>
        <p>Discover a haven of relaxation at Fairmont Spa Monte Carlo. Personalized facial and body treatments, 
            soothing massages and exclusive beauty rituals await in an elegant setting, complemented by a sauna, hammam and Monaco-exclusive 111Skin treatments.</p>
        <ul>
        <li><strong>Relaxing Massage: </strong>This soothing full-body massage features slow, flowing strokes designed to ease 
            physical tension and calm the nervous system &ndash; it&rsquo;s perfect for those seeking deep relaxation, renewal 
            and a sense of balance. Massage services at the spa are provided exclusively by female therapists.</li>
        </ul>
        <ul>
        <li><strong>Reparative Facial: </strong>This results-driven facial is rich in antioxidants that help soothe, repair and 
            protect the skin. Featuring a double cleanse, this treatment restores the skin&rsquo;s natural barrier, reduces inflammation and deeply hydrates for a healthy, radiant complexion.</li>
        </ul>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="capitalModal" tabindex="-1" aria-labelledby="capitalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/activities/nice.jpg">
        <h5 class="modal-title col-11" id="capitalLabel">Nice – The Capital of the French Riveria</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>Offered: </strong>Tuesday, March 16 and Friday, March 19<br>
        <strong>Time: </strong>Tuesday 11:15 AM &ndash; 4:00 PM, Friday 8:45 AM &ndash; 2:30 PM</p>
        <p>Discover the charm of Nice as you explore its architectural treasures, browse the colorful 
            shops and markets, and linger over a sumptuous lunch. Highlights you may want to take in 
            while in Nice include the Flower Market in Old Town, bursting with blooms and sweet fragrances; 
            Place Mass&eacute;na, the main square with its distinctive geometric-patterned pavement and arcaded 
            buildings surrounding the monumental Fountain of the Sun; Avenue Jean M&eacute;decin, the main shopping street; 
            and Place Garibaldi, the oldest major square in Nice with beautiful architecture and a slower pace. 
            You&rsquo;ll find a charming caf&eacute; scene in Place Garibaldi as well as in the vibrant Cours Saleva of 
            Old Town or along the Rue Mass&eacute;na, the pedestrian boulevard lined with sunny terraces from which to enjoy the stunning view of the Mediterranean while you dine.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="shoppingModal" tabindex="-1" aria-labelledby="shoppingLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/activities/dolce-vita.jpg">
        <h5 class="modal-title col-11" id="shoppingLabel">Dolce Vita & Shopping in Italy</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>Offered: </strong>Tuesday, March 16 and Friday, March 19<br>
        <strong>Time: </strong>Tuesday 10:45 AM &ndash; 4:30 PM, Friday 8:15 AM &ndash; 3:00 PM</p>
        <p>Head across the border to discover the sweet life in San Remo, Italy. During this outing, 
            you may want to browse one of the Riviera&rsquo;s largest open-air markets, where colorful stalls brim with 
            clothing, leather goods, household wares and local specialties, then continue to Corso Matteotti for designer 
            labels, inviting caf&eacute;s and charming independent boutiques. Beyond the shops, you can explore the narrow medieval 
            lanes and panoramic viewpoints of La Pigna, admire the historic Basilica di San Siro, or stroll toward the landmark Casino 
            di Sanremo and the domes of the Russian Orthodox Church. For lunch, you may want to stop in Porto Vecchio (the Old Harbor) 
            to enjoy fresh seafood dishes as you admire the yachts at the marina or head to the city center. Be sure to pick up 
            authentic Italian pasta or olive oil to take home as a memento of your day in Italy.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="cannesModal" tabindex="-1" aria-labelledby="cannesLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/activities/cannes.jpg">
        <h5 class="modal-title col-11" id="cannesLabel">Cannes – City of the Stars</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>Offered: </strong>Tuesday, March 16 and Friday, March 19<br>
        <strong>Time: </strong>Tuesday 11:00 AM &ndash; 4:15 PM, Friday 8:45 AM &ndash; 3:45 PM</p>
        <p>Get swept up in the glamour of the City of Stars. Once a small fishing village, Cannes was transformed into an 
            international capital of cinema and Riviera style. To experience its star-studded allure, start with a stroll along 
            La Croisette, the celebrated seaside boulevard lined with grand hotels and luxury boutiques, then pose on the famous 
            steps of the Palais des Festivals et des Congr&egrave;s, home of the iconic film festival, and discover celebrity 
            handprints along the city&rsquo;s Walk of Fame. To shop like a celebrity, browse designer fashions, jewelry and 
            antiques on Rue d&rsquo;Antibes before venturing into Le Suquet, the historic hilltop quarter to take in the panoramic 
            views over the Vieux Port and the Mediterranean. You may also want to wander through the stalls of the March&eacute; 
            Forville and admire the local produce and regional specialties on display or simply relax on one of Cannes&rsquo; 
            celebrated beaches and gaze out on the sparkling Mediterranean. For lunch, you have an abundance of choices from inviting 
            beachside restaurants along La Croisette or waterfront venues overlooking the yachts in the Old Port.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="lemonModal" tabindex="-1" aria-labelledby="lemonLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header row g-0">
        <img class="activity-img" src="assets/images/activities/menton.jpg">
        <h5 class="modal-title col-11" id="lemonLabel">Menton "City of the Lemon"</h5>
        <button type="button" class="btn-close col-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><strong>Offered: </strong>Tuesday, March 16 and Friday, March 19<br>
        <strong>Time: </strong>Tuesday 10:30 AM &ndash; 3:45 PM, Friday 9:45 AM &ndash; 2:30 PM</p>
        <p>Pucker up and discover the sun-kissed charm of Menton, the &ldquo;Pearl of France&rdquo; and celebrated 
            &ldquo;City of the Lemon.&rdquo; This colorful Riviera town near the Italian boarder blends French elegance 
            with an unmistakable Italian influence. To truly experience this beautiful town, you&rsquo;ll want to wander 
            through the stairways and pastel-hued lanes of Vieux-Menton, pause amid the caf&eacute;s and local life of Place 
            des Herbes, then admire the baroque Basilique Saint-Michel Archange and the beautiful Mediterranean views from 
            its elevated square. Throughout town, you&rsquo;ll see Menton&rsquo;s prized lemons featured in everything from 
            gourmet specialties to beauty, home and wellness products, so be sure to pick up a lemon-inspired souvenir of your 
            visit. You may also want to stroll the palm-lined Promenade du Soleil, explore the floral displays of Jardin Biov&egrave;s 
            or discover the artistic legacy of Jean Cocteau. When you&rsquo;ve worked up an appetite, you&rsquo;ll find inviting 
            restaurants for lunch near the market hall in the city center or along the upper and lower beachfront areas.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-activities" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>